var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFemale = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  "aria-hidden": "true",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M5 11C5 4.925 9.925 0 16 0s11 4.925 11 11c0 5.738-4.393 10.45-10 10.955V26h4v2h-4v4h-2v-4h-4v-2h4v-4.045C9.393 21.45 5 16.738 5 11m11-9a9 9 0 1 0 0 18 9 9 0 0 0 0-18",
  clipRule: "evenodd"
})));
export default SvgFemale;